import Phaser from 'phaser';

export class SimpleScene extends Phaser.Scene {
  planet1!: Phaser.Physics.Arcade.Sprite;
  planet2!: Phaser.Physics.Arcade.Sprite;

  constructor() {
    super('SimpleScene');
  }

  preload() {
    this.load.image('planet', 'assets/planet.svg');
    this.load.image('space-bg', 'assets/space-bg.svg');
  }

  create() {
    var centerX = this.cameras.main.width / 2;
    var centerY = this.cameras.main.height / 2;
    this.add.image(centerX, centerY, 'space-bg').setDepth(-1);
    this.planet1 = this.physics.add.sprite(200, 300, 'planet').setScale(0.1);
    this.planet2 = this.physics.add.sprite(600, 300, 'planet').setScale(0.1);
    this.planet1.setTint(0x00ff00);
    this.planet2.setTint(0x0000ff);
    this.planet1.setVelocity(0, 30);
    this.planet2.setVelocity(0, -30);
  }

  update() {
    let G = 20000; // 调整引力常数以获得更自然的运动效果

    // 计算两个星球之间的距离向量
    const m1 = 1;
    const m2 = 1;
    const dx = this.planet2.x - this.planet1.x;
    const dy = this.planet2.y - this.planet1.y;
    let distanceSq = dx * dx + dy * dy;
    let distance = Math.sqrt(distanceSq);

    // 计算引力大小
    const force = G * m1 * m2 / distanceSq;

    // 计算加速度
    const acc1 = force / m1;
    const acc2 = force / m2;
    const acc1x = acc1 * dx / distance;
    const acc1y = acc1 * dy / distance;
    const acc2x = acc2 * dx / distance;
    const acc2y = acc2 * dy / distance;

    // 更新速度
    this.planet1.body!.velocity.x += acc1x;
    this.planet1.body!.velocity.y += acc1y;
    this.planet2.body!.velocity.x -= acc2x;
    this.planet2.body!.velocity.y -= acc2y;
  }
}


